module.exports = __webpack_public_path__ + "img/pengboshi03.09fc669b.png";